



































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import GroupsDetails from "@/components/GroupsDetails.vue";
import SearchFilter from "@/components/Utilities/SearchFilter.vue";
import { Group } from "@/services/Group";
import { VehicleType } from "@/services/VehicleType";
import HelpContent from "../HelpContent.vue";
import LeftClickOptionMenu from "@/components/Utilities/LeftClickOptionMenu.vue";

@Component({
  components: {
    GroupsDetails,
    SearchFilter,
    HelpContent,
    LeftClickOptionMenu
  },
})
export default class GroupsSearchPage extends Vue {
  firstSearch: boolean = false;
  showLoading: boolean = false;
  groupSelected: Group = new Group("", null, "", null);
  loading: boolean = false;
  searchFilter: any = {
    freeText: null,
    groupCode: null,
    description: null,
  };
  vehiclesTypesList: VehicleType[] = [];
  placeholder: string = "Search by code or description";
  page: number = 1;
  resultsItems: any = {
    resultPage: new Array(),
    total: 0,
  };
  newGroup: Group = new Group(null, null, null, null);
  modal_helpGroupSearch: string = "modal-helpGroupSearch"

  //pacchetto per menu tasto destro su dettaglio entita'
  leftClickOptionMenuUrl: string = "/groups/";
  leftClickOptionMenuUrlArgument: string = "groupCode";
  handleClick (event, item) {
    (this.$refs.leftClickOptions as LeftClickOptionMenu).handleClick(event, item);
  }

  openAddModal() {
     if(this.$route.params.id)
    this.$router.push("/groups");
    this.$bvModal.show("group-add-modal");
  }

  get GroupTitle(): string {
    return `Group code: ${this.groupSelected.groupCode}`;
  }

  async searchGroup(filter: any, start: boolean = true) {
    this.showLoading = true;
    if (start == true) this.resetSearch();

    try {
      let results: any = await axios({
        method: "post",
        url: General.GetApiUrl("/api/lubricationTable/GetGroupsWithFilter"),
        data: {
          FreeText: filter.freeText,
          GroupCode: filter.groupCode,
          Description: filter.description,
          CurrentPage: this.page,
        },
        withCredentials: true,
        responseType: "json",
      });
      this.resultsItems.resultPage = this.resultsItems.resultPage.concat(
        results.data.listPage
      );
      this.resultsItems.total = results.data.total;
      this.firstSearch = true;

      if (this.resultsItems.resultPage.length >= this.resultsItems.total)
        this.page = 1;
      else this.page += 1;
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.showLoading = false;
    }
  }

  openGroup(group: Group, setRouterId: boolean = true) {
    this.setGroupSelected(group);
    if (setRouterId)
      this.$router.push("/groups/" + this.groupSelected.groupCode);
    this.showGroupModalDetail();
  }

  showGroupModalDetail() {
    this.$bvModal.show("group-detail-modal");
  }

  setGroupSelected(group: Group) {
    this.groupSelected.idGroup = group.idGroup;
    this.groupSelected.groupCode = group.groupCode;
    this.groupSelected.description = group.description;
  }

  closeGroup() {
    this.$bvModal.hide("group-detail-modal");
  }
  async mounted() {
    await this.getVehicleTypes();

    if (this.$route.params.id) {
      let code = this.$route.params.id;
      let results: any = await axios({
        method: "post",
        url: General.GetApiUrl("/api/lubricationTable/GetGroupsWithFilter"),
        data: {
          GroupCode: code,
        },
        withCredentials: true,
        responseType: "json",
      });
      this.openGroup(results.data.listPage[0], false);
    }
  }
  searchFilterSearchEvent(genericSearch: string) {
    if (genericSearch != undefined) this.searchFilter.freeText = genericSearch;
    this.searchGroup(this.searchFilter, true);
  }

  resetSearch() {
    this.firstSearch = false;
    this.resultsItems.resultPage.splice(0);
    this.page = 1;
  }

  async getVehicleTypes() {
    try {
      let vehiclesTypes = await axios.get<VehicleType[]>(
        General.GetApiUrl("/api/lubricationTable/GetVehicleTypes"),
        {
          withCredentials: true,
          responseType: "json",
        }
      );
      this.vehiclesTypesList = vehiclesTypes.data;
    } catch (ex) {
      General.HandleError(ex, this);
    }
  }

  canManageLubTable() {
    return General.CanManageLubTable();
  }
  
}
